import { createEditorPlatformApp } from './platform/createEditorPlatformApp';

export const { editorReady, getAppManifest, handleAction, exports } =
  createEditorPlatformApp();
